const input = "_uxsi1lh33f3";
const title = "_uxstba8c6s";
const answer = "_uxsa2rn6e";
const line = "_uxsl1dt787a";

export { answer, input, line, title };
import "./molecule.inputs.style.linaria.module.css";
//# sourceMappingURL=molecule.inputs.style.js.map
